import React from 'react';
import { useParams } from 'react-router-dom';
import EditForm from '../components/editForm/EditForm';
import { useGetSingleBookQuery } from '../features/api/apiSlice';

const Edit = () => {
    const {bookId} = useParams();
    const {data:book, isLoading, isError} = useGetSingleBookQuery(bookId);

    return (
        <main class="py-6 2xl:px-6">
        <div class="container">
            <div class="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
                <h4 class="mb-8 text-xl font-bold text-center">Edit Book</h4>
               {isLoading ? <div>Loading...</div> : <EditForm book={book}/>}
            </div>
        </div>
    </main>
    );
};

export default Edit;